<script lang="ts">
import LegalPage from "$lib/legal/LegalPage.svelte";
</script>

<LegalPage slug="data-processing" />
